import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {REQUEST_WALL} from '../../core/handlers.actions';
import {IWall} from '../../core/models/wall';
import {IPost} from '../../core/models/post';
import BrickLayout from '../wall/brick';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { IconButton} from '@material-ui/core';
import { User } from '../../core/models/user';
import PostAddEdit from '../post/add.edit';
// import PostValidationModal from '../modal';
// import RegularLayout from '../wall/regular';

interface Props {
  getWall: (wallId:string) => void;
  wall:IWall; 
  wallId:string;
  posts: [IPost];
  user:User;
  eventName: string | boolean;
}

interface State {
    validationFormOpen:boolean;
    readyToAddPost:boolean;
}

class General extends Component<Props,State> {   
    state:State = {validationFormOpen:false, readyToAddPost:false};
    
    componentDidMount(){
        const {wallId, getWall} = this.props;
        getWall(wallId);
        this.splitTitle = this.splitTitle.bind(this);
        this.addPost = this.addPost.bind(this);
        this.validationFormHandler = this.validationFormHandler.bind(this);
        this.dismissAddEditPostComponent = this.dismissAddEditPostComponent.bind(this);
        this.renderHtml = this.renderHtml.bind(this);
    }

    public validationFormHandler(){
        this.setState({...this.state, validationFormOpen: !this.state.validationFormOpen});
    }

    public addPost(){
       //  const {wall, user} = this.props;     
        // if(wall.postRequiresUserInfo === 'Yes' && !user.userInfo.userInfoSubmission) return this.validationFormHandler();
        // if(wall.postRequiresUserInfo === 'Optional' && !user.userInfo.userInfoDismissed) return this.validationFormHandler();
        this.setState({...this.state, readyToAddPost: true});
    }

    public splitTitle(title:string){
        if(!title) return;
        const words = title.split(' ');
        const half = Math.ceil(words.length / 2);
        const firstHalf = words.splice(0, half).toString().replace(/,/g, ' ');
        const secondHalf = words.splice(-half).toString().replace(/,/g, ' ');
        return {__html: `${firstHalf} <span class="green">${secondHalf}</span>`};
    }

    public renderHtml(data:any){
        return {__html: data};
    }

    public dismissAddEditPostComponent(){
        this.setState({...this.state, readyToAddPost: !this.state.readyToAddPost})
    }

   public render(){       
       const {wall, eventName} = this.props;  
       const { readyToAddPost} = this.state;    
       
        return(
            <div className="app-container" id="wall-wrapper-21">
                <div className="app-content">
                    <div className="title-section">
                        <h1 className="wall-title" dangerouslySetInnerHTML={this.renderHtml(wall.title)} />
                        <p className="subtitle" dangerouslySetInnerHTML={this.renderHtml(wall.subTitle)} />
                    </div>  
                    <div className="add-post-section">                        
                        <IconButton className="add-button" onClick={this.addPost}><p className="add-text">Add A Story</p>&nbsp;&nbsp;<AddBoxIcon/></IconButton>
                    </div>
                    <div >
                        {(readyToAddPost)? (<div className="new-post-holder"><PostAddEdit requiresUserContactInfo={wall.postRequiresUserInfo} needsApproval={wall.postRequiresApproval} action={this.dismissAddEditPostComponent} tags={wall.feedTags} edit={false} tagsRef={wall.wallTagsRef} featuredTag={wall.postFeaturedTag}/></div>):null}  
                        {wall.layout === 'bricks' ? (<BrickLayout eventName={eventName}/>): (/*<RegularLayout/>*/null)}
                        <div className="innershadow"></div>    
                    </div>                  
                </div>
                {/* <PostValidationModal isValidationOpen={validationFormOpen} action={this.validationFormHandler} type={wall.postRequiresUserInfo === 'Yes' ? 'Required': 'Optional'} /> */}
            </div> 
        );
    }
}
/** map props */
const props = (app:any) => ({wall: app.rootReducer.wall, posts: app.rootReducer.posts, user: app.rootReducer.user});
const dispatch = (dispatch:Dispatch) => ({
    getWall: (wallId:string) => dispatch({type: REQUEST_WALL, payload: wallId})  
});
export default connect(props, dispatch)(General);
